import { useMutation } from '@tanstack/react-query';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export interface FeedbackInput {
  title: string;
  description: string;
  category: 'bug' | 'improvement' | 'question';
  impact: 'blocking' | 'high' | 'medium' | 'low';
  bounty_id?: string;
  page_url?: string;
  user_agent?: string;
}

interface FeedbackResponse {
  id: string;
  status: string;
  message: string;
}

async function submitFeedback(data: FeedbackInput): Promise<FeedbackResponse> {
  const res = await fetch(`${API_BASE}/api/feedback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    let message = 'Failed to submit feedback';
    try {
      const body = await res.json();
      message = body.error || message;
    } catch {
      // non-JSON error response
    }
    throw new Error(message);
  }
  return res.json();
}

export function useFeedback() {
  return useMutation({
    mutationFn: submitFeedback,
  });
}
